import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "Infrastructure Without the Overhead",
    text: "Leverage world-class data centers without the cost and complexity of building or managing your own.",
  },
  {
    image: SocImg,
    title: "Flexible Deployment at Any Scale",
    text: "From single-server hosting to full-rack solutions, scale seamlessly as your business grows.",
  },
  {
    image: MonitoringImg,
    title: "​Total Control, Zero Headaches",
    text: "Retain full ownership of your hardware while we handle the uptime, environment, and on-site support.",
  },
];
